<template>
  <div>
    <div v-if="account.reseller" class="row">
      <div class="col-md-12">
        <div class="card card-stats card-raised">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-primary">
                      <i class="now-ui-icons users_single-02"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="clients.filter(client => client.status === 'VERIFIED' && client.ResellerId === account.reseller.id).length"> </animated-number>
                    </h3>
                    <h6 class="stats-title">{{$ml.get('number_of_client')}}</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-primary">
                      <i class="now-ui-icons ui-1_zoom-bold"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="clients.filter(client => client.ResellerId === account.reseller.id).length"></animated-number>
                    </h3>
                    <h6 class="stats-title">{{$ml.get('total_investigated')}}</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-primary">
                      <i class="now-ui-icons business_money-coins"></i>
                    </div>
                    <h3 class="info-title">
                      <small>€</small>
                      <animated-number :value="account.reseller.current_earnings"> </animated-number>
                    </h3>
                      <h6 class="stats-title"> {{$ml.get('money_earned_this_month')}} </h6>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-primary">
                      <i class="now-ui-icons business_money-coins"></i>
                    </div>
                    <h3 class="info-title">
                      <small>€</small>
                      <animated-number :value="account.reseller.earnings"></animated-number>
                    </h3>
                    <h6 class="stats-title">{{$ml.get('total_money_earned')}}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    StatsCard,
    Card,
    Table as NTable,
    Checkbox,
    AnimatedNumber,
    Progress as NProgress
  } from '../../../components'
  import { mapGetters } from 'vuex';

  export default {
    components: {
      Checkbox,
      Card,
      NTable,
      StatsCard,
      AnimatedNumber,
      NProgress
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['clients'])
    },
    mounted () {},
    methods: {}
  }
</script>
<style scoped>
.card-title {
  font-size: 15px;
}
.card-category {
  font-size: 22px;
}
</style>
